import { api } from "./httpClient";

export interface SuperadminClientInvestmentRow {
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  projectInvested: number;
  packInvested: number;
  totalInvested: number;
}

export type SuperadminBoardPeriod = "day" | "week" | "month" | "all";

export interface SuperadminBoardQuery {
  period?: SuperadminBoardPeriod;
  page?: number;
  limit?: number;
}

export interface SuperadminBoardSummary {
  projectInvested: number;
  packInvested: number;
  totalInvested: number;
}

export interface SuperadminBoardResponse {
  rows: SuperadminClientInvestmentRow[];
  summary: SuperadminBoardSummary;
}

export interface SuperadminBoardMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  period: SuperadminBoardPeriod;
}

export const listClientInvestmentsBoard = async (params?: SuperadminBoardQuery) => {
  const response = await api<SuperadminBoardResponse>({
    method: "GET",
    url: "/admin/superadmin/client-investments",
    params,
  });

  return {
    data: response.data.data ?? { rows: [], summary: { projectInvested: 0, packInvested: 0, totalInvested: 0 } },
    meta: (response.data.meta ?? null) as SuperadminBoardMeta | null,
  };
};
